export enum OrderPaymentType {
  Portfolio = 'PORTFOLIO',
  BankAccount = 'BANK_ACCOUNT',
  None = 'NONE',
}
